import { EmptyState, FlexColumn, useStyles } from '@gorila-shared-ui/components';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { EvidenceMedia } from '../../../types/evidences';
import StreamingMediaItem from './StreamingMediaItem';

type Props = {
  states?: EvidenceMedia[];
  extended?: boolean;
};
export function StreamingMediaLibrary({ states, extended = false }: Readonly<Props>) {
  const { css } = useStyles();

  if (!states?.length) {
    return <EmptyState title="No cuenta con registros de evidencias." />;
  }

  return (
    <FlexColumn classNames={`${css({ flex: 1, overflow: 'hidden' })}`}>
      <FlexGrid
        flexGridColumnCount={[1, 1, 1, 1, 2]}
        flexGridColumnGap="scale600"
        flexGridRowGap="scale600"
        overflow="auto"
      >
        {states.map((media, mediaIndex) => (
          <FlexGridItem
            display="flex"
            key={mediaIndex}
            style={{ position: 'relative' }}
          >
            <StreamingMediaItem media={media} />
          </FlexGridItem>
        ))}
      </FlexGrid>
    </FlexColumn>
  );
}
